import React from "react";
import {
    FaBars,
    FaCar,
    FaClipboardList,
    FaFileInvoice,
    FaListAlt,
    FaTools,
    FaUsers,
    FaUserTie,
    FaBoxes,
    FaMoneyCheckAlt,
    FaCalculator,
    FaCalendarCheck,
    FaChartBar,
    FaGift,
    FaChartLine,
    FaChartPie,
    FaBuilding,
    FaDatabase
} from "react-icons/fa";
import { AiFillInfoCircle } from "react-icons/ai";
import { useWorkshop } from "../Common/WorkshopContext";
import SidebarGroup from "./SidebarGroup";
import SidebarItem from "./SidebarItem";

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
    const { workshopId, loanEnabled, workshopEnabled } = useWorkshop();

    // Define grouped items
    const workshopItems = [
        { icon: <FaTools />, text: "Workshops", link: `/workshops/dashboard/${workshopId}` },
        { icon: <FaUserTie />, text: "Employees", link: "/employees" },
        { icon: <FaListAlt />, text: "Work Types", link: "/work-types" },
        { icon: <FaClipboardList />, text: "Job Cards", link: "/job-cards" },
        { icon: <FaBoxes />, text: "Inventory", link: "/workshop/inventory" },
        { icon: <FaFileInvoice />, text: "Bills", link: "/workshop/bills" },

        { icon: <FaGift />, text: "Loyalty Cards", link: "/loyalty-card/dashboard" },
    ];

    const loanItems = [
        { icon: <FaMoneyCheckAlt />, text: "Loans", link: "/workshop/loans" },
        { icon: <FaCalculator />, text: "Loan Calculator", link: "/loans/calculator" },
        { icon: <FaCalendarCheck />, text: "EMI List", link: "/loans/emis/pending" },
    ];

    const loanReportsItems = [
        { icon: <FaChartBar />, text: "Loan Dashboard", link: "/loans/dashboard" },
        { icon: <FaChartLine />, text: "Finance Reports", link: "/loans/finance-reports" },
        { icon: <FaChartPie />, text: "Economic Unit Report", link: "/loans/economic-unit-report" },
        { icon: <FaBuilding />, text: "Loan Branches", link: "/branches" },
        { icon: <FaCalculator />, text: "Operational Expenses", link: "/workshop/operational-expenses" }
    ];

    return (
        <div
            className={`h-screen bg-teal-500 text-white fixed top-0 left-0 transition-all duration-300 ${
                isCollapsed ? "w-20" : "w-64"
            }`}
        >
            {/* Toggle Button */}
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="w-full py-3 flex items-center justify-center bg-teal-500 transition"
            >
                <FaBars className="text-xl" />
            </button>

            {/* Sidebar Items */}
            <nav className="mt-5 flex flex-col gap-2">
                {/* General */}
                <SidebarItem icon={<AiFillInfoCircle />} text="AI Chat" link="/ai-chat" collapsed={isCollapsed} />
                <SidebarItem icon={<FaUsers />} text="Customers" link="/customers" collapsed={isCollapsed} />
                <SidebarItem icon={<FaCar />} text="Assets" link="/workshop/assets" collapsed={isCollapsed} />
                <SidebarItem icon={<FaDatabase />} text="Data Tools" link="/data-tools" collapsed={isCollapsed} />

                {/* Workshop Section */}
                {workshopEnabled && <SidebarGroup icon={<FaTools />} title="Workshop Management" items={workshopItems} collapsed={isCollapsed} />}

                {/* Loans Section */}
                {loanEnabled && (
                    <>
                        <SidebarGroup icon={<FaMoneyCheckAlt />} title="Loans" items={loanItems} collapsed={isCollapsed} />
                        <SidebarGroup icon={<FaChartBar />} title="Loan Analytics" items={loanReportsItems} collapsed={isCollapsed} />
                    </>
                )}
            </nav>
        </div>
    );
};

export default Sidebar;